// extracted by mini-css-extract-plugin
module.exports = {"primary":"#36ae6c","secondary":"#3a3a3c","surface":"#fff","accent":"#40fe96","brand":"#000","textBrand":"#fff"};